export default "__VITE_ASSET__DRQO3bzk__"